import parsePhoneNumberFromString, { CountryCode } from 'libphonenumber-js';

export function formatPhoneNumber(
  phoneNumber: string,
  defaultCountry: CountryCode = 'FR',
) {
  const parsed = parsePhoneNumberFromString(phoneNumber, defaultCountry);

  if (parsed && parsed.isValid()) {
    return parsed.formatNational(); // Returns the phone number in national format
  }

  return phoneNumber; // Fallback to the original input if formatting fails
}
